import CheckInButton from "../CheckInButton/CheckInButton";
import CheckInAvailability from "./CheckInAvailabilty";

const CheckInRequired = ({ eventData, show = true }) => {
  if (!show) {
    return <></>;
  }

  return (
    <div
      style={{
        border: "1px solid #c2bab5",
        borderRadius: ".25rem",
        padding: ".5rem",
        backgroundColor: "#fafafa",
      }}
    >
      <div className={"d-flex"}>
        <div className={"left_flex"}>
          <strong
            style={{
              fontSize: "16px",
            }}
          >
            This booking event requires check in
          </strong>
          <br />
          <span
            style={{
              fontSize: "14px",
            }}
          >
            <CheckInAvailability eventData={eventData} />
          </span>
        </div>
        <div className={"right_flex"}>
          <CheckInButton key={eventData?.id} item={eventData} />
        </div>
      </div>
    </div>
  )
}

export default CheckInRequired
